import { Card } from "antd";
import React from "react";

interface PartnersCardProps {
  partner: any;
}

const PartnersCard = ({ partner }: PartnersCardProps) => {
  return (
    <Card className="takaful--partner-card">
      <div className="takaful--partner-image-container">
        <img
          alt="partner logo"
          src={partner?.image}
        />
      </div>
      <div className="takaful--partner-card-content">
        <h3 className="takaful--partner-card-title">{partner.title}</h3>
        <p className="takaful--partner-card-description">{partner.details}</p>
      </div>
    </Card>
  );
};

export default PartnersCard;
